import { CheckCircle2, Clock, Snowflake, Heart, Truck, Sparkles } from "lucide-react";

const pillars = [
  { icon: Sparkles, color: "bg-ice-pink", title: "Slow-cooked, never shortcut", body: "Every batch starts at 4am with real milk reduced for 4–6 hours. No vegetable fat, no powdered milk, ever." },
  { icon: Snowflake, color: "bg-mint", title: "−18°C cold chain", body: "From plant to parlour to your party — temperature monitored, never broken. The texture you taste is the texture we made." },
  { icon: Heart, color: "bg-sun-yellow-soft", title: "Three-generation recipe", body: "The family recipe, written by hand in 1999, hasn't changed. Improved equipment, same instinct." },
  { icon: Truck, color: "bg-ice-pink", title: "Bulk catering, on call", body: "Wedding tomorrow? School event today? Same-day delivery across Gorakhpur. Cups, spoons & ribbons included." },
  { icon: Clock, color: "bg-mint", title: "24×7. Yes, really.", body: "3am ice-cream emergencies? We've got you. The counter never sleeps." },
  { icon: CheckCircle2, color: "bg-sun-yellow-soft", title: "FSSAI certified", body: "Every flavour is FSSAI batch-tested before it leaves the plant. Premium, traceable, safe." },
];

export default function Speciality() {
  return (
    <section className="py-12 md:py-16" data-testid="speciality-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-xs tracking-[0.2em] uppercase text-holiday-red font-bold">Our Speciality</p>
        <h1 className="font-display text-5xl md:text-7xl leading-[0.95] mt-3">Six reasons<br/><span className="text-holiday-red italic font-serif">we never compromise.</span></h1>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {pillars.map((p, i) => (
            <article key={i} className={`${p.color} rounded-[2rem] p-7 cushion border border-[#F0E4E4]`} data-testid={`speciality-${i}`}>
              <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center mb-4">
                <p.icon className="w-5 h-5 text-holiday-red"/>
              </div>
              <h3 className="font-display text-2xl">{p.title}</h3>
              <p className="text-sm leading-relaxed text-choc/80 mt-3">{p.body}</p>
            </article>
          ))}
        </div>

        {/* Process strip */}
        <div className="mt-20 bg-white rounded-[2rem] p-8 md:p-12 cushion border border-[#F0E4E4]" data-testid="process-strip">
          <h2 className="font-display text-3xl md:text-4xl">The Holiday process</h2>
          <ol className="mt-8 grid md:grid-cols-4 gap-6">
            {["Source", "Slow-cook", "Hand-fold", "Freeze & deliver"].map((s, i) => (
              <li key={s} className="relative">
                <div className="text-7xl font-display text-holiday-red/15 leading-none">0{i+1}</div>
                <h3 className="font-serif text-xl mt-2">{s}</h3>
                <p className="text-sm text-choc/70 mt-1.5 leading-relaxed">{["Local dairies in Gorakhpur, picked daily.","Reduced for hours till silken & sweet.","Mix-ins added by hand, batch by batch.","−18°C cold chain to your home or event."][i]}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}

